import {
  AGE,
  AGES,
  MARITAL_STATUS,
  PARTNER_NAME,
  TAX_FILING_STATE,
  INCOME,
  EXPENSES,
  CHILDREN,
  CHILDREN_DETAILS,
  LARGE_PURCHASE_YEAR,
  LARGE_PURCHASE_NAME,
  LARGE_PURCHASE_VALUE,
  EARMARKED_ACCOUNTS,
} from '../SummaryConstants';

const DICTIONARY = {
  [MARITAL_STATUS]: {
    iterator: [1, 0],
    title: 'Partner',
  },
  [PARTNER_NAME]: {
    iterator: [1, 1],
    title: 'Partner\'s Name',
  },
  [AGES]: {
    iterator: [1, 2],
    title: 'Ages',
  },
  [AGE]: {
    iterator: [1, 2],
    title: 'Age',
  },
  [CHILDREN]: {
    iterator: [1, 3],
    title: 'Children',
  },
  [CHILDREN_DETAILS]: {
    iterator: [1, 4],
    title: 'Children Details',
  },
  [TAX_FILING_STATE]: {
    iterator: [2, 0],
    title: 'Tax Filing State',
  },
  [INCOME]: {
    iterator: [3, 0],
    title: 'Income',
  },
  [EXPENSES]: {
    iterator: [4, 0],
    title: 'Expenses',
  },
  [LARGE_PURCHASE_NAME]: {
    iterator: [5],
    title: 'Item',
  },
  [LARGE_PURCHASE_VALUE]: {
    iterator: [6],
    title: 'Purchase Amount',
  },
  [LARGE_PURCHASE_YEAR]: {
    iterator: [7],
    title: 'Purchase Year',
  },
  [EARMARKED_ACCOUNTS]: {
    iterator: [8, 1],
    title: 'Earmarked Accounts',
  },
};
export default DICTIONARY;
